import GoogleMapReact from 'google-map-react';
import React, { useEffect } from 'react';
import mapStyleData from '../map.json';

// This could be your marker component
const Marker = () => <div><img src="/path/to/marker.png" alt="marker" />📍</div>; 

const Map = ({ location }) => {

const mapStyle = mapStyleData;

const API_KEY = "AIzaSyAAa0Poy6oJW0ZV8HdJBynbnExTKICHrSk";

const coordinates = [Number(location.lat), Number(location.lng)]

let initialCoordinates;

useEffect(() => {
    initialCoordinates = coordinates
}, []);

return (
    <div className="h-[440px] w-full">
      {location && location.lat && location.lng ? (
        <GoogleMapReact
          bootstrapURLKeys={{ key: API_KEY }}
          defaultCenter={initialCoordinates}
          center={coordinates}
          defaultZoom={16}
          yesIWantToUseGoogleMapApiInternals
          options={{ 
            zoomControl: false, 
            draggable: false, 
            styles: mapStyle }}
        >
          <Marker
            lat={location.lat}
            lng={location.lng}
            style={{ width: '100px', height: '100px' }}
          />
        </GoogleMapReact>
      ) : (
        <div>Loading map...</div>
      )}
    </div>
  );
};

export default function SimpleMap(props) {
  return (
    <Map
      location={props.location}
    />
  );
}

